import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import getters_search from "./getters_search";

export default {
  namespaced: true,
  state,
  actions: Object.assign({}, actions),
  mutations,
  getters: Object.assign({}, getters, getters_search)
};
